import React from 'react';
import { Section } from './ui/Section';
import { MapPin, Clock } from 'lucide-react';
export function Location() {
  return <Section id="location" className="bg-[#FFF8E7]" data-id="element-59">
      <div className="max-w-5xl mx-auto bg-white shadow-2xl overflow-hidden rounded-sm border border-[#2C2416]/10" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-61">
          {/* Info Side */}
          <div className="p-12 md:p-16 flex flex-col justify-center bg-[url('https://www.transparenttextures.com/patterns/cream-paper.png')]" data-id="element-62">
            <h2 className="text-5xl text-[#2C2416] mb-8" data-id="element-63">Visit Us</h2>

            <div className="space-y-8" data-id="element-64">
              <div className="flex items-start space-x-4" data-id="element-65">
                <div className="mt-1 text-[#D4735E]" data-id="element-66">
                  <MapPin size={24} data-id="element-67" />
                </div>
                <div data-id="element-68">
                  <h3 className="text-2xl text-[#2C2416] mb-2 font-bold font-serif" data-id="element-69">
                    Address
                  </h3>
                  <p className="text-lg text-[#2C2416]/80 font-serif" data-id="element-70">
                    13 Walm Ln
                    <br data-id="element-71" />
                    London NW2 5SJ
                    <br data-id="element-72" />
                    United Kingdom
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-73">
                <div className="mt-1 text-[#D4735E]" data-id="element-74">
                  <Clock size={24} data-id="element-75" />
                </div>
                <div data-id="element-76">
                  <h3 className="text-2xl text-[#2C2416] mb-2 font-bold font-serif" data-id="element-77">
                    Opening Hours
                  </h3>
                  <div className="text-lg text-[#2C2416]/80 font-serif grid grid-cols-2 gap-x-8" data-id="element-78">
                    <span data-id="element-79">Mon - Thu</span>
                    <span data-id="element-80">17:00 - 22:00</span>
                    <span data-id="element-81">Fri - Sat</span>
                    <span data-id="element-82">17:00 - 23:00</span>
                    <span data-id="element-83">Sunday</span>
                    <span data-id="element-84">16:00 - 21:30</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map Side (Visual representation) */}
          <div className="relative h-full min-h-[400px] bg-[#2C2416]" data-id="element-85">
            <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=1974&auto=format&fit=crop" alt="Restaurant interior" className="absolute inset-0 w-full h-full object-cover opacity-60 mix-blend-overlay" data-id="element-86" />
            <div className="absolute inset-0 flex items-center justify-center p-8 text-center" data-id="element-87">
              <div className="bg-[#FFF8E7]/90 p-8 backdrop-blur-sm border-2 border-[#D4735E]" data-id="element-88">
                <span className="font-serif italic text-[#2C2416] text-xl" data-id="element-89">
                  "The best pizza in Willesden Green"
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}